import cn from 'classnames'
import { FaUser } from 'react-icons/fa'

import s from './ProfilePhoto.scss'

const ProfilePhoto = ({ src, className }) => (
  <div className={cn(className, s.mainPhoto)}>
    {src ? <img className={s.photo} src={src} /> : <FaUser />}
  </div>
)

export default ProfilePhoto
